// convert CE to BE date
const convertCEToBE = (dateVal) => {
  const dateObj = new Date(dateVal);
  const year = dateObj.getFullYear() + 543;
  const month = dateObj.getMonth() + 1; // JavaScript months are 0-based
  const day = dateObj.getDate();

  // Construct the date string in 'DD/MM/YYYY' format and return
  return `${day}/${month}/${year}`
}

// get day name in Thai
const getDayNameTH = (dateString) => {
  const date = new Date(dateString);
  if (!dateString) return "-";
  const daysTH = ['อาทิตย์', 'จันทร์', 'อังคาร', 'พุธ', 'พฤหัสบดี', 'ศุกร์', 'เสาร์'];
  return daysTH[date.getDay()];
}

// get day name in Thai by index (0-6)
// 0 = อาทิตย์, 1 = จัทร์, ..., 6 = เสาร์
// Returns "-" if index is invalid
const getDayNameTHByIndex = (dayIndex) => {
  const daysTH = ['อาทิตย์', 'จันทร์', 'อังคาร', 'พุธ', 'พฤหัสบดี', 'ศุกร์', 'เสาร์'];
  if (dayIndex == null || dayIndex < 0 || dayIndex > 6) return "-";
  return daysTH[dayIndex];
}

// Convert date to 'YYYY-MM-DD' format
const toDateString = (dateVal) => {
  const dateObj = new Date(dateVal);
  const year = dateObj.getFullYear();
  const month = String(dateObj.getMonth() + 1).padStart(2, '0');
  const day = String(dateObj.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
}

// Format date as DD/MM/YYYY in Thai BE locale
const formatDateTH = (dateVal) => {
  if (!dateVal) return '-';
  return new Date(dateVal).toLocaleDateString('th-TH', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
  });
}

// Format datetime as DD/MM/YYYY HH:mm in Thai BE locale
const formatDateTimeTH = (dateVal) => {
  if (!dateVal) return '-';
  return new Date(dateVal).toLocaleString('th-TH', {
    day:    '2-digit',
    month:  '2-digit',
    year:   'numeric',
    hour:   '2-digit',
    minute: '2-digit',
  });
}

module.exports = {
  convertCEToBE,
  getDayNameTH,
  toDateString,
  getDayNameTHByIndex,
  formatDateTH,
  formatDateTimeTH,
}